import AppIcon from "common/app-icon";
import { PushDropdown } from "notebook/push-dropdown/push-dropdown";
import React from "react";
import { useLayer } from "react-laag";
import SectionHeader, { SectionHeaderButtonProps } from "../section-header/section-header";
import { OverviewSectionStyle } from "./overview-section-style";

export enum SortMode {
    OldestFirst = "Oldest first",
    NewestFirst = "Newest first",
    Alphabetical = "Alphabetical",
}

interface Props {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    button?: SectionHeaderButtonProps;
    currentSortMode?: SortMode;
    onSort?: (sortMode: SortMode) => void;
}

const OverviewScreenSection = (props: React.PropsWithChildren<Props>) => {
    const { title, subtitle, button, children, onSort, currentSortMode } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const { layerProps, renderLayer, triggerProps } = useLayer({
        isOpen,
        container: "portal",
        auto: true,
        placement: "bottom-end",
        onOutsideClick: () => setIsOpen(false),
    });

    return (
        <OverviewSectionStyle>
            <SectionHeader name={title} button={button}>
                {subtitle}
                {onSort !== undefined && (
                    <div className="sort-button" {...triggerProps} onClick={() => setIsOpen(c => !c)}>
                        <div>{currentSortMode ?? SortMode.OldestFirst}</div>
                        <AppIcon icon="caret" size={10} strokeWidth={1} className="sort-caret" />
                        {isOpen &&
                            renderLayer(
                                <div {...layerProps}>
                                    <PushDropdown
                                        items={[SortMode.OldestFirst, SortMode.NewestFirst, SortMode.Alphabetical]}
                                        descriptionForItem={x => x}
                                        selected={currentSortMode}
                                        onItemSelect={onSort}
                                    />
                                </div>
                            )}
                    </div>
                )}
            </SectionHeader>
            <div className="ovsc-tile-region">{children}</div>
        </OverviewSectionStyle>
    );
};

export default OverviewScreenSection;
